import React from 'react';
import PropTypes from 'prop-types';

import './RoundSectionTeaser.module.css';

RoundSectionTeaser.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
  }),
};

RoundSectionTeaser.defaultProps = {
  data: null,
};

function RoundSectionTeaser({ data }) {
  return (
    <a
      href={data.target}
      styleName="RoundSectionTeaser"
      style={{
        backgroundImage: `url('${data.image}')`,
      }}
    >
      <span>{data.title}</span>
      <span>{data.subtitle}</span>
    </a>
  );
}

export default RoundSectionTeaser;



// WEBPACK FOOTER //
// ./src/components/FourColumnsBlock/RoundSectionTeaser.js